<template>
    <div class="page-data">
        <slot v-if="showPage && commonDataReady" />
        <skeleton
            v-else
            :count="6"
            :column="4"
            animate
            class="page-data-skeleton"
            :style="skeletonStyle"
        />
    </div>
</template>

<script>
import Skeleton from '@/components/skeleton';
import { loadResource } from '@tencent/qd-lib';
import { setWindowPageData } from './utils';
import staticResource from '@/config/resourceConfig';
import store from './store';

export default {
  name: 'PageData',
  components: {
    Skeleton,
  },
  props: {
    /**
       * @type {Array<() => Promise> ｜ () => Promise}
       * 渲染前的钩子，包括但不限于PAGE_DATA接口获取等；除了默认的PAGE_DATA可能还有别的操作
       * 例如 [ () => { return this.$ajax.gatewayget('/call/settings/page_data').then((res) => res.data) } ]
       */
    beforeRenderHooks: {
      type: [Array, Function],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showPage: false,
      contentHeight: 0,
    };
  },
  computed: {
    skeletonStyle() {
      return {
        height: `${this.contentHeight}px`,
      };
    },
    hasHoooks() {
      return typeof this.beforeRenderHooks === 'function' || (Array.isArray(this.beforeRenderHooks) && this.beforeRenderHooks.length > 0);
    },
    commonDataReady() {
      return store.state.commonDataReady;
    },
  },
  watch: {
    '$route'(route) {
      // 设置 title（路由 meta.title 是中文 key，通过 i18n 翻译）
      this.applyDocumentTitle(route);
      // 拿到当前页面路由meta中配置的需要加载的资源信息
      const sourceMap = route.meta?.sourceList || {};
      // 把资源信息map转换为数组[{key, url}]，保证顺序
      const sourceList = Object.keys(sourceMap).map(key => ({ key, url: sourceMap[key] }));

      this.init([this.loadPageData(), sourceList.map(source => this.loadSource(source))].flat(Infinity));
    },
    // 语言切换时，同步刷新当前页面标题（运行时切语言场景；首屏 reload 场景由 $route watcher 兜底）
    '$i18n.locale'() {
      this.applyDocumentTitle(this.$route);
    },
  },
  mounted() {
    // 首屏首次设置 title（$route watcher 不会在初始化时触发）
    this.applyDocumentTitle(this.$route);
  },
  methods: {
    /**
     * 根据路由 meta.title 翻译并写入 document.title
     * @param {object} route Vue Router route 对象
     */
    applyDocumentTitle(route) {
      const title = route && route.meta && route.meta.title;
      if (!title) return;
      document.title = this.$te && this.$te(title) ? this.$t(title) : title;
    },
    loadSource({ key, url }) {
      if (!staticResource[key]) {
        // 这里统一使用数组来处理
        const urls = Array.isArray(url) ? url : [url];
        return urls.map(url => new Promise(((resovle) => {
          loadResource(url, () => {
            staticResource[key] = true;
            resovle();
          });
        })));
      }
      return [];
    },
    loadPageData() {
      if (this.$route.meta && this.$route.meta.dataUrl) {
        return this.$ajax.gatewayGet(this.$route.meta.dataUrl)
          .then((res) => {
            setWindowPageData(res.data || res);
            return res.data || res;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      return [];
    },
    init(promises) {
      this.showPage = false;
      Promise.allSettled(promises)
        .finally(() => {
          this.showPage = true;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.page-data {
  width: 100%;
  height: 100%;

  &-skeleton {
      justify-content: center;
  }
}
</style>
